import { useQuery } from '@tanstack/react-query';
import { client } from '../api';
import {
  formatDrugName,
  prescriberNamesToDropdownOptions,
  stringsToDropdownOptions,
} from 'shared-utils/utils/dropdownFilter';
import { DropdownOption } from 'shared-utils/types/dropdownFilter';

export type PortalTableFilterOptions = {
  prescribers: DropdownOption[];
  offices: DropdownOption[];
  drugs: DropdownOption[];
};

export const useFetchPortalTableFilters = () => {
  return useQuery({
    queryKey: ['portal-table-filter-options'],
    queryFn: () =>
      client.get('/portal-table-filter-options').then((res) => {
        return {
          prescribers: prescriberNamesToDropdownOptions(res.data.prescribers),
          offices: stringsToDropdownOptions(res.data.offices),
          drugs: stringsToDropdownOptions(res.data.drugs, formatDrugName),
        } as PortalTableFilterOptions;
      }),
  });
};
